import { useState, useEffect, useContext } from "react";
import { 
    Modal, 
    Box, 
    Typography, 
    Button, 
    Paper,
    Divider,
    IconButton
} from "@mui/material"; 
import { Close as CloseIcon } from "@material-ui/icons";
import * as commonFnc from '../../common/commonFnc';
import { GlobalContext } from '../../globalState';

const KintaiDitailModal = (props) => {
    const {kintai_bsc, userName, modalOpen, handleModalClose, shiftMst} = props;

    const Env_msts = useContext(GlobalContext).Env_msts;
    const count1 = Env_msts.find(p=>p.env_key==="COUNT1");
    const count2 = Env_msts.find(p=>p.env_key==="COUNT2");
    const count3 = Env_msts.find(p=>p.env_key==="COUNT3");
    const count4 = Env_msts.find(p=>p.env_key==="COUNT4");
    const count5 = Env_msts.find(p=>p.env_key==="COUNT5");

    const custom1 = Env_msts.find(p=>p.env_key==="CUSTOM1");
    const custom2 = Env_msts.find(p=>p.env_key==="CUSTOM2");
    const custom3 = Env_msts.find(p=>p.env_key==="CUSTOM3");
    const custom4 = Env_msts.find(p=>p.env_key==="CUSTOM4");
    const custom5 = Env_msts.find(p=>p.env_key==="CUSTOM5");

    const [modalKintaiBsc, setModalKintaiBsc] = useState(kintai_bsc || {});

    const [overWorkInfo, setOverWorkInfo] = useState([]);
    const [paidHolidayInfo, setPaidHolidayInfo] = useState(null);
    const [clockinInfo, setClockinInfo] = useState(null);

    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        
        const fetchData = async () => {
        
            if (kintai_bsc && !isLoading) {
                setIsLoading(true);
                setModalKintaiBsc(kintai_bsc);
                await fetch(`/api/select/request_overtime?login_user_id=${kintai_bsc.user_id}&date=${commonFnc.formatDate(kintai_bsc.date)}`)
                    .then((res) => res.json())
                    .then((data) => setOverWorkInfo(data));
                await fetch(`/api/select/request_paid_holiday?login_user_id=${kintai_bsc.user_id}&date=${commonFnc.formatDate(kintai_bsc.date)}`)
                    .then((res) => res.json())
                    .then((data) => setPaidHolidayInfo(data));
                await fetch(`/api/select/clockin_jarnal?user_id=${kintai_bsc.user_id}&date=${commonFnc.formatDate(kintai_bsc.date)}`)
                    .then((res) => res.json())
                    .then((data) => setClockinInfo(data));
                setIsLoading(false);
            }
        }
        fetchData();
        
    }, [kintai_bsc]);

    useEffect(() => {
        if(!modalOpen){
            setModalKintaiBsc({});
            setOverWorkInfo([]);
            setPaidHolidayInfo(null);
            setIsLoading(false);
        }
    }, [modalOpen]);


    const convertJst = (dateTime) => {
        const targetDate = new Date(dateTime);
        const jstOffset = 9 * 60 * 60 * 1000;
        const targetDateJST = new Date(targetDate.getTime() + jstOffset);
        return targetDateJST;
    }

    // 48時間形式でHH:mm形式の時刻を表示する関数（JST対応）
    const formatTimeWith48Hour = (dateTime, baseDate) => {
        if (!dateTime || !baseDate) {
            return '--:--';
        }

        // JST（UTC+9）に変換
        const targetDate = convertJst(dateTime);
        const base = new Date(baseDate);

        // 基準日の00:00からの経過時間を計算（JST基準）
        const diffMs = targetDate.getTime() - base.getTime();
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        
        // 48時間形式で表示（24時間を超える場合は25:00, 26:00...と表示）
        const displayHours = diffHours;
        const displayMinutes = diffMinutes;
        
        return `${String(displayHours).padStart(2, '0')}:${String(displayMinutes).padStart(2, '0')}`;
    };

    
    const formatTime = (dateTime, baseDate) => {
        
        if (!dateTime || !baseDate) {
            return '--:--';
        }

        // JST（UTC+9）に変換
        const targetDate = convertJst(dateTime);
        const base = new Date(baseDate);

        // 基準日の00:00からの経過時間を計算（JST基準）
        const diffMs = targetDate.getTime() - base.getTime();
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        
        // 翌日の場合は翌日の実際の時刻を表示
        if (diffHours >= 24) {
            // 翌日の時刻を計算（24時間を引いて翌日の時刻を取得）
            const nextDayHours = diffHours - 24;
            const nextDayMinutes = diffMinutes;
            return `翌${String(nextDayHours).padStart(2, '0')}:${String(nextDayMinutes).padStart(2, '0')}`;
        }
        
        return `${String(diffHours).padStart(2, '0')}:${String(diffMinutes).padStart(2, '0')}`;
    };

    const VIEW_48HOUR = true;
    const formatShiftTime = VIEW_48HOUR ? formatTimeWith48Hour : formatTime;

    
    


    const styles = {
        modal: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            maxWidth: '90vw',
            maxHeight: '90vh',
            overflow: 'auto',
            outline: 'none'
        },
        paper: {
            padding: 3,
            borderRadius: 2,
            boxShadow: 24
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 2
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        detailRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0'
        },
        label: {
            fontWeight: 'bold',
            color: '#666'
        },
        value: {
            color: '#333',
            padding: '2px 5px',
            borderRadius: '5px',
            minWidth: '50px',
        },
        detailDataWrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'top',
            padding: '0',
            width: '100%',
            marginBottom: '10px'
        },
        detailDataContent: {
            width: '50%'
        },
        detailDataLeLeftContent: {
            paddingRight: '16px'
        },
        detailDataRow:{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0'
        },
        closeButton: {
            position: 'absolute',
            top: 8,
            right: 8
        },
        footer: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: 3,
            paddingTop: 2,
            borderTop: '1px solid #e0e0e0'
        }
    };


    // 独自コンポーネント
    const shiftComponent = (shift_type_cd, styles) => {
        if (!shift_type_cd) return null;
        const shift = shiftMst.find((p)=>p.shift_type_cd === shift_type_cd);
        const style = {
            ...styles.value, 
            backgroundColor: shift.backgroundcolor || '#f0f0f0',
            color: shift.textcolor,
            textAlign: 'center'
        }
        return (
            <Typography sx={style}>{shift.shift_name}</Typography>
        )
    }

    const countComponent = (count, modalKintaiBscCountValue, styles) => {
        if(count.log_del_flg) return null
        
        const style = {
            ...styles.label, 
            borderBottom: modalKintaiBscCountValue ? '2px solid rgb(51, 252, 148)' : 'none',
            textDecoration: !modalKintaiBscCountValue ? 'line-through' : 'none',
            marginRight: '20px',
            textAlign: 'center'
        }
        return (
            <Typography sx={style}>{count.env_value}</Typography>
        )
    }

    const customComponent = (custom, modalKintaiBscCustomValue, styles) => {
        if(custom.log_del_flg) return null
        const style = {
            ...styles.label, 
            marginRight: '20px',
            textAlign: 'center'
        }
        return (
            <Box>
                <Typography sx={style}>{custom.env_value}</Typography>
                <Typography sx={style}>{commonFnc.getHHmm(modalKintaiBscCustomValue)}</Typography>
            </Box>
        )
    }

    return (
        <Modal 
            open={modalOpen} 
            onClose={handleModalClose}
            aria-labelledby="kintai-detail-modal"
        >
            <Box sx={styles.modal}>
                <Paper sx={styles.paper}>
                    {/* ヘッダー */}
                    <Box sx={styles.header}>
                        <Typography variant="h6" component="h2" id="kintai-detail-modal">
                            勤怠詳細
                        </Typography>
                        <Typography variant="h6" component="h2" id="kintai-detail-modal">
                            {userName}
                        </Typography>
                        <IconButton 
                            onClick={handleModalClose}
                            sx={styles.closeButton}
                            size="small"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Divider sx={{ marginBottom: 2 }} />

                    {/* コンテンツ */}
                    <Box sx={styles.content}>
                        {isLoading ? <div class="loader">Loading...</div> : modalKintaiBsc && Object.keys(modalKintaiBsc).length > 0 ? (
                            <>
                                {/* 基準日を表示 */}
                                {modalKintaiBsc.date && (
                                    <Box sx={styles.detailRow}>
                                        <Typography sx={styles.label}>日付:</Typography>
                                        <Typography sx={styles.value}>
                                            {commonFnc.formatDate(modalKintaiBsc.date)}
                                        </Typography>
                                    </Box>
                                )}
                                {/* シフト */}
                                {modalKintaiBsc.date && (
                                    <Box sx={styles.detailRow}>
                                        <Typography sx={styles.label}>シフト:</Typography>
                                        <Box sx={{display: 'flex', gap: 1}}>
                                            {shiftComponent(modalKintaiBsc.shift_type_cd, styles)}
                                            {shiftComponent(modalKintaiBsc.harf_holiday_shift_type_cd, styles)}
                                            {shiftComponent(modalKintaiBsc.paid_holiday_shift_type_cd, styles)}
                                        </Box>
                                    </Box>
                                )}

                                {paidHolidayInfo && (
                                    <Box sx={styles.detailRow}>
                                        <Typography sx={styles.label}>有給理由:</Typography>
                                        <Typography sx={styles.value}>{paidHolidayInfo.request_paid_holiday_reason}</Typography>
                                    </Box>
                                )}

                                {/* 48時間形式での開始・終了時刻 */}
                                {modalKintaiBsc.date && (() => {
                                    const shift = shiftMst.find((p)=>p.shift_type_cd === modalKintaiBsc.shift_type_cd);
                                    
                                    if (!shift) {
                                        return (
                                            <Box sx={styles.detailRow}>
                                                <Typography sx={styles.label}>シフト時刻:</Typography>
                                                <Typography sx={styles.value}>--:-- - --:--</Typography>
                                            </Box>
                                        );
                                    }
                                    
                                    let displayShiftTimeTo = shift.shift_time_to;
                                    
                                    // 48h表記の場合
                                    // if(shift.shift_time_to_date_flg==='2'){
                                    //     const toHour = parseInt(shift.shift_time_to.split(':')[0]) + 24;
                                    //     const toMinute = parseInt(shift.shift_time_to.split(':')[1]);

                                    //     displayShiftTimeTo = toHour.toString().padStart(2, '0') + ":" + toMinute.toString().padStart(2, '0');
                                    //  }
                                    
                                    return (
                                        <Box sx={styles.detailRow}>
                                            <Typography sx={styles.label}>シフト時刻:</Typography>
                                            <Typography sx={styles.value}>
                                                {shift.shift_time_from || "--:--"} - {shift.shift_time_to_date_flg==='2'&&"翌"}{displayShiftTimeTo || "--:--"}
                                            </Typography>
                                        </Box>
                                    )
                                })()}

                                {/* 48時間形式での開始・終了時刻 */}
                                {modalKintaiBsc.date && (
                                    <Box sx={styles.detailRow}>
                                        <Typography sx={styles.label}>勤務時刻:</Typography>
                                        <Typography sx={styles.value}>
                                            {formatShiftTime(modalKintaiBsc.work_time_from, modalKintaiBsc.date) + " - " + formatShiftTime(modalKintaiBsc.work_time_to, modalKintaiBsc.date)}
                                        </Typography>
                                    </Box>
                                )}

                                {/* 打刻開始・終了時刻 */}
                                {modalKintaiBsc.date && clockinInfo && (
                                    <Box sx={styles.detailRow}>
                                        <Typography sx={styles.label}>打刻時刻:</Typography>
                                        <Typography sx={styles.value}>
                                            {formatShiftTime(clockinInfo.clockin_time, modalKintaiBsc.date) + " - " + formatShiftTime(clockinInfo.clockout_time, modalKintaiBsc.date)}
                                        </Typography>
                                    </Box>
                                )}
                                
                                {/* 残業情報も48時間形式で表示 */}
                                {overWorkInfo.map((info, index) => (
                                    <Box key={index} sx={styles.detailRow}>
                                        <Typography sx={styles.label}>残業時刻</Typography>
                                        <Typography sx={styles.value}>
                                            {`${formatShiftTime(info.over_time_from, modalKintaiBsc.date)} - ${formatShiftTime(info.over_time_to, modalKintaiBsc.date)}`}
                                            <br/>
                                            {info.reason}
                                        </Typography>
                                    </Box>
                                ))}

                                <Divider sx={{ marginBottom: 2 }} />
                                <Box sx={styles.detailDataWrapper}>
                                    {/* その他の勤怠情報 */}
                                    <Box sx={{...styles.detailDataContent, ...styles.detailDataLeLeftContent}}>

                                        <Box sx={styles.detailDataRow}>
                                            <Typography sx={styles.label}>勤務時間:</Typography>
                                            <Typography sx={styles.value}>
                                                {modalKintaiBsc.work_time ? commonFnc.getHHmm(modalKintaiBsc.work_time) : '--:--'}
                                            </Typography>
                                        </Box>
                                            
                                        
                                        <Box sx={styles.detailDataRow}>
                                            <Typography sx={styles.label}>休憩時間:</Typography>
                                            <Typography sx={styles.value}>
                                                {modalKintaiBsc.rest_time ? commonFnc.getHHmm(modalKintaiBsc.rest_time) : '--:--'}
                                            </Typography>
                                        </Box>
                                        
                                        <Box sx={styles.detailDataRow}>
                                            <Typography sx={styles.label}>時間外:</Typography>
                                            <Typography sx={styles.value}>
                                                {modalKintaiBsc.over_time ? commonFnc.getHHmm(modalKintaiBsc.over_time) : '--:--'}
                                            </Typography>
                                        </Box>
                                        
                                        <Box sx={styles.detailDataRow}>
                                            <Typography sx={styles.label}>深夜:</Typography>
                                            <Typography sx={styles.value}>
                                                {modalKintaiBsc.midnight_over_time ? commonFnc.getHHmm(modalKintaiBsc.midnight_over_time) : '--:--'}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box sx={styles.detailDataContent}>
                                        
                                        <Box sx={styles.detailDataRow}>
                                            <Typography sx={styles.label}>遅早時間:</Typography>
                                            <Typography sx={styles.value}>
                                                {modalKintaiBsc.behind_time ? commonFnc.getHHmm(modalKintaiBsc.behind_time||0 + modalKintaiBsc.early_time||0) : '--:--'}
                                            </Typography>
                                        </Box>
                                        
                                        <Box sx={styles.detailDataRow}>
                                            <Typography sx={styles.label}>業務外:</Typography>
                                            <Typography sx={styles.value}>
                                                {modalKintaiBsc.training_time ? commonFnc.getHHmm(modalKintaiBsc.training_time) : '--:--'}
                                            </Typography>
                                        </Box>
                                        
                                    </Box>
                                </Box>
                                
                                <Divider sx={{ marginBottom: 2 }} />
                                {/* カウント */}
                                <Box sx={styles.detailDataWrapper}>
                                    <Box sx={styles.detailRow}>
                                        {countComponent(count1, modalKintaiBsc.count1, styles)} 
                                        {countComponent(count2, modalKintaiBsc.count2, styles)}
                                        {countComponent(count3, modalKintaiBsc.count3, styles)}
                                        {countComponent(count4, modalKintaiBsc.count4, styles)}
                                        {countComponent(count5, modalKintaiBsc.count5, styles)}
                                    </Box>  
                                </Box>

                                <Divider sx={{ marginBottom: 2 }} />
                                {/* カスタム */}
                                <Box sx={styles.detailDataWrapper}>
                                    <Box sx={styles.detailRow}>
                                        {customComponent(custom1, modalKintaiBsc.custom1, styles)} 
                                        {customComponent(custom2, modalKintaiBsc.custom2, styles)}
                                        {customComponent(custom3, modalKintaiBsc.custom3, styles)}
                                        {customComponent(custom4, modalKintaiBsc.custom4, styles)}
                                        {customComponent(custom5, modalKintaiBsc.custom5, styles)}
                                    </Box>  
                                </Box>
                            </>
                        ) : (
                            <Typography color="text.secondary" textAlign="center" sx={{ py: 4 }}>
                                勤怠データがありません
                            </Typography>
                        )}
                    </Box>
                    {/* フッター */}
                    <Box sx={styles.footer}>
                        <Button 
                            variant="contained" 
                            onClick={handleModalClose}
                            sx={{ minWidth: 100 }}
                        >
                            閉じる
                        </Button>
                    </Box>
                </Paper>
            </Box>
        </Modal>
    );
};

export default KintaiDitailModal;